"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const utils_1 = require("@osmosys/utils");
let FeatureFlags = class FeatureFlags {
    constructor() {
        this.adsManager = null;
        this.newCampaignSendPage = null;
        this.useNewLoaderForEmailQuery = null;
        this.useNewSalesforceCategoryInterfaces = null;
        this.useNewLoaderForEmailSubjectLineMutation = null;
        this.includeDefaultContentFeedInEmailQuery = null;
        // @Field(() => Boolean, { defaultValue: null, nullable: true })
        // writeRenderedHtmlToDraftEmailHtml?: boolean | null = null;
        this.useNewLightweightSendCampaignMutationForTestCampaigns = null;
        this.useNewLightweightSendCampaignMutationForProductionCampaigns = null;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "adsManager", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "newCampaignSendPage", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "useNewLoaderForEmailQuery", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "useNewSalesforceCategoryInterfaces", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "useNewLoaderForEmailSubjectLineMutation", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "includeDefaultContentFeedInEmailQuery", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "useNewLightweightSendCampaignMutationForTestCampaigns", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { defaultValue: null, nullable: true }),
    tslib_1.__metadata("design:type", Object)
], FeatureFlags.prototype, "useNewLightweightSendCampaignMutationForProductionCampaigns", void 0);
FeatureFlags = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    type_graphql_1.InputType('FeatureFlagsInput')
], FeatureFlags);
exports.FeatureFlags = FeatureFlags;
exports.dropNullFeatureFlags = (obj) => {
    const def = new FeatureFlags();
    return Object.entries(obj || {}).reduce((acc, [key, val]) => {
        if (utils_1.isDefined(val) && key in def) {
            acc[key] = val;
        }
        return acc;
    }, {});
};
//# sourceMappingURL=FeatureFlags.js.map